import { Pill } from "@hm/fundamental"
import { CycleStatus } from "@shared/api/cycles/types"
import { useTranslation } from "react-i18next"

export interface CycleStatusPillProps {
	status: CycleStatus
	"data-cy"?: string
}

export const CycleStatusPill: React.FC<CycleStatusPillProps> = ({
	status,
	"data-cy": dataCy = "cycle-status-pill",
}) => {
	const { t } = useTranslation("shared", {
		keyPrefix: "cycleStatusPill",
	})

	const cycleStatusToPillPropsMap: Record<
		CycleStatus,
		{
			type: React.ComponentProps<typeof Pill>["type"]
			text: string
		}
	> = {
		[CycleStatus.New]: {
			type: "neutral",
			text: t("new"),
		},
		[CycleStatus.AwaitingAssurance]: {
			type: "warning",
			text: t("awaitingAssurance"),
		},
		[CycleStatus.Rejected]: {
			type: "negative",
			text: t("rejected"),
		},
		[CycleStatus.Assured]: {
			type: "positive",
			text: t("assured"),
		},
		[CycleStatus.Failed]: {
			type: "negative",
			text: t("failed"),
		},
		[CycleStatus.RequireMoreInformation]: {
			type: "warning",
			text: t("inValidation"),
		},
	}

	const { text, type } = cycleStatusToPillPropsMap[status]

	return (
		<Pill
			text={text}
			type={type}
			variant="shade"
			shape="rounded"
			data-cy={dataCy}
		/>
	)
}
